import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'; // Adjust if using a different modal service
import { CustomerService } from '../customer.service';
import { Router } from '@angular/router';
import { NotificationService } from 'src/app/core/services/notification.service';

@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-modal.component.html'
})
export class ConfirmationModalComponent {
  @Input() message!: string; 
  userId:any

  constructor(public activeModal: NgbActiveModal,
    private customerService: CustomerService,
    private route: Router,
    private notifyService: NotificationService
  ) {}

  close() {
    this.activeModal.close();
    this.route.navigate(["/customer/profile"]);
  }

  ngOnInit(): void {
    this.userId = localStorage.getItem("customer_UserId");
  }

  publishProfile(){
    let resData = {
      iUserId: this.userId
    };

      let notificationData = {
        iUserId: null,
        vNotificationTitle: "New Profile Published!!",
        vNotificationBody: " Someone has just Published their Profile, assist them further",
        txNotificationRoute: '/member/role-management/tickets',
      }
    this.customerService.PublishForm(resData).subscribe(
      (result: any) => {
        if (result.code === 200) {
          this.notifyService.showSuccess(result.message, "");
          this.activeModal.close();
          
          this.notifyService.addNotification(notificationData).subscribe(
            (result: any) => {
              if (result.code == 200) {
                console.log(result, 'result in notification');
              } else {
                console.log('Error in notification');
              }
            },
            (error: any) => {
              console.error('Error in notification:', error);
            }
          );
    
          this.route.navigate(["/customer/profile"]);
        } else {
          this.notifyService.showError(result.message, "");
        }
      },
      (error: any) => {
        console.error("API Call Failed:", error);
      }
    );
  }
}
